( function( app ) {
  const COMPONENT = {
    className: 'circle-cta',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      $( '.circle-cta .wysiwyg a[class*="btn"]' ).on( 'mouseenter', ( e ) => {
        e.target.closest( '.circle-cta' )?.classList.add( 'is-hovered' );
      } ).on( 'mouseleave', ( e ) => {
        e.target.closest( '.circle-cta' )?.classList.remove( 'is-hovered' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'circle-cta', COMPONENT );
} )( app );
